// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2fEeX","content":"GlobalSearch_content__ZwLwo"};